<a *ngIf="!locked" [href]="url" target="_blank">{{ title }}</a>
<a *ngIf="locked" href="#" (click)="openBuyLicense($event)">{{ title }} <i aria-hidden="true" class="fa fa-lock"></i></a>
